<template lang="pug">
	div
		div.card
			div.card-img-top.bg-light.text-center(v-if="!locutor.info")
				img(style="height:80px;margin:5px;", src="/static/recursos/hombre.svg", v-if="locutor.titulo.match(/^loc[0-9]/)")
				img(style="height:80px;margin:5px;", src="/static/recursos/mujer.svg", v-if="locutor.titulo.match(/^loca[0-9]/)")
				img(style="height:80px;margin:5px;", src="/static/recursos/otro.svg", v-if="locutor.titulo.match(/^locx[0-9]/)")

			div.card-img-top.bg-light.text-center(v-if="locutor.info")
				img.rounded-circle.border(style="height:80px;margin:5px;", :src="locutor.info.avatar", alt="loc")

			div.card-block.p-2
				h6.card-title {{locutor.titulo}}
				div.card-text.text-danger(v-if="!locutor.info") Sin definir
				div.card-text(v-if="locutor.info") {{locutor.info.nombre}} {{locutor.info.apellidos}}

			div.card-footer.p-1(v-if="tarea.fase !== 'finalizada' && esUltima && permisos.produccion_asignaLocutores")
				div.row
					div.col-xs-6.col-sm-6.col-md-6.col-xl-6.col-lg-6.text-left
						button.btn.btn-sm.btn-info.mr-2(@click="locutorActual = locutor.titulo")
							span.fa.fa-user-o

						button.btn.btn-sm.btn-danger(@click="desasignaLocutor(locutor.titulo)")
							span.fa.fa-trash
				//
					div.col-xs-6.col-sm-6.col-md-6.col-xl-6.col-lg-6.text-right
						button.btn.btn-sm.btn-warning(@click="uploadOff(locutor)")
							span.fa.fa-upload
		selecciona-locutor(v-if="locutorActual", :tarea="tarea", :etiqueta="locutorActual", @cerrar="locutorActual = null", @seleccion="asignaLocutor($event)")
		input(type="file", ref="input", @change="doUpload($event)", style="display:none;")
</template>

<script>
import { mapGetters } from 'vuex'
import SeleccionLocutor from '../seleccion-locutor'
import API from '../../../services/api'
export default {
	props: ['tarea', 'locutor', 'versionActual'],
	components: {
		'selecciona-locutor': SeleccionLocutor
	},
	data () {
		return {
			locutorActual: null
		}
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos'
		}),
		esUltima () {
			return this.versionActual.ultima_version.ultima
		}
	},
	methods: {
		asignaLocutor (locutor) {
			if (!this.locutorActual) {
				return
			}

			// Veamos si ese locutor ya está asignado
			for (let i = 0; i < this.versionActual.locutores.length; i++) {
				if (this.versionActual.locutores[i].info && this.versionActual.locutores[i].info.ID_locutor === locutor.ID_locutor) {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: 'Este locutor ya está asignado'
					})
					return
				}
			}

			const datos = {
				ID_version: this.versionActual.ID_version,
				titulo: this.locutorActual,
				ID_locutor: locutor.ID_locutor
			}

			API.asignaLocutor(datos)
				.then(res => {
					this.$emit('update:versionActual', res.data.version)
					this.locutorActual = null
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		desasignaLocutor (loc) {
			const datos = {
				ID_version: this.versionActual.ID_version,
				titulo: loc,
				ID_locutor: null
			}

			API.asignaLocutor(datos)
				.then(res => {
					this.$emit('update:versionActual', res.data.version)
					this.locutorActual = null
				})
				.catch(e => {
					this.$store.commit('alertas/nueva', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		uploadOff () {
			const inp = this.$refs.input
			inp.click()
		},
		doUpload (file) {
			console.log('Ey, hacemos un upload')
			const inp = this.$refs.input
			console.log(inp.files)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/componentes/tarjeta-locutor.vue